import { useEffect } from 'react'
import RichText from './RichText'

export default function SyntheseModal({ company, synthese, evolution, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className="bg-white shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col border border-[#77726e]/30"
        onClick={e => e.stopPropagation()}
      >
        <div className="px-5 py-3.5 border-b border-[#77726e]/20 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <p className="text-[0.65rem] font-semibold uppercase tracking-wide text-[#77726e] mb-0.5">
              Synthèse détaillée
            </p>
            <p className="text-sm font-medium text-[#2f3126] truncate" title={company}>{company}</p>
          </div>
          <button
            onClick={onClose}
            className="shrink-0 text-[#77726e] hover:text-[#2f3126] text-lg leading-none transition"
          >
            ✕
          </button>
        </div>
        <div className="overflow-auto p-5 flex-1">
          <RichText text={synthese} />
          {evolution && (
            <div className="mt-4 pt-4 border-t border-[#77726e]/20">
              <h4 className="text-[0.65rem] font-bold text-[#77726e] uppercase tracking-wide mb-1.5">
                Évolution
              </h4>
              <RichText text={evolution} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
